import { render, staticRenderFns } from "./ViewAdvertisement.vue?vue&type=template&id=6dfd59f7&scoped=true&"
import script from "./ViewAdvertisement.vue?vue&type=script&lang=js&"
export * from "./ViewAdvertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd59f7",
  null
  
)

export default component.exports